// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2fssm","col":"styles_col__20VD_"};